const initialState = {
    reference: {
        numDossier: null,
        numSiren: null,
        departments: [],
        typeDemande: null,
    },
    caracConvoi: {
        accompagnement: false,
        masseTotaleVide: null,
        longueurVide: null,
        largeurVide: null,
        hauteurVide: null,
        masseTotaleCharge: null,
        longueurCharge: null,
        largeurCharge: null,
        hauteurCharge: null,
        natureCharge: null,
        vitesseCircuCharge: null,
        category: null,
        nbVehicule: null,
        nbTransExcept: null,
        nbRames: null,
        configurations: [],
    },
    complInfo: {
        dateArrete: null,
        desc1Number: null,
        desc1Date: null,
        desc1Label: null,
        desc2Number: null,
        desc2Date: null,
        desc2Label: null,
        horPassDebut: null,
        horPassFin: null,
        servTeInfo: null,
        servOaInfo: null,
        refCtr: [],
    },
    trajetDescr: {
        depart: null,
        arrivee: null,
        type: null,
        descr: [{
            numeroSection: null,
            nomSection: null,
            passType: null,
            charge: null,
            contresens: false,
            demontage: false,
            elemPatri: [],
            expanded: true,
            road: null,
            centre: null,
            centres: [],

            pointTypeEnter: null,
            pointCaracEnter: null,
            sensSectionEnter: null,
            citySectionEnter: null,
            prSectionEnter: null,

            pointTypeExit: null,
            pointCaracExit: null,
            sensSectionExit: null,
            citySectionExit: null,
            prSectionExit: null,
        }],
        descrRetour: [{
            numeroSection: null,
            nomSection: null,
            passType: null,
            charge: null,
            contresens: false,
            demontage: false,
            elemPatri: [],
            expanded: true,
            road: null,
            centre: null,
            centres: [],

            pointTypeEnter: null,
            pointCaracEnter: null,
            sensSectionEnter: null,
            citySectionEnter: null,
            prSectionEnter: null,

            pointTypeExit: null,
            pointCaracExit: null,
            sensSectionExit: null,
            citySectionExit: null,
            prSectionExit: null,
        }],
    },
};

const requestPassReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_REFERENCE':
            return {
                ...state,
                reference: {
                    ...state.reference,
                    ...action.payload,
                },
            };
        case 'UPDATE_REFERENCE':
            return {
                ...state,
                reference: {
                    ...state.reference,
                    [action.payload.name]: action.payload.value,
                },
            };
        case 'CLEAR_REFERENCE':
            return {
                ...state,
                reference: {
                    numDossier: null,
                    numSiren: null,
                    departments: [],
                    typeDemande: null,
                },
            };
        case 'LOAD_REFERENCE':
            return {
                ...state,
                reference: {
                    ...state.reference,
                    ...action.payload,
                },
            };
        case 'UPDATE_CARAC_CONVOI':
            return {
                ...state,
                caracConvoi: {
                    ...state.caracConvoi,
                    [action.payload.name]: action.payload.value,
                },
            };
        case 'CLEAR_CARAC_CONVOI':
            return {
                ...state,
                caracConvoi: {
                    accompagnement: false,
                    masseTotaleVide: null,
                    longueurVide: null,
                    largeurVide: null,
                    hauteurVide: null,
                    masseTotaleCharge: null,
                    longueurCharge: null,
                    largeurCharge: null,
                    hauteurCharge: null,
                    natureCharge: null,
                    vitesseCircuCharge: null,
                    category: null,
                    nbVehicule: null,
                    nbTransExcept: null,
                    nbRames: null,
                    configurations: [],
                },
            };
        case 'LOAD_CARAC_CONVOI':
            return {
                ...state,
                caracConvoi: {
                    ...state.caracConvoi,
                    ...action.payload,
                },
            };
        case 'UPDATE_INFOS_COMPL':
            return {
                ...state,
                complInfo: {
                    ...state.complInfo,
                    [action.payload.name]: action.payload.value,
                },
            };
        case 'CLEAR_INFOS_COMPL':
            return {
                ...state,
                complInfo: {
                    dateArrete: null,
                    desc1Number: null,
                    desc1Date: null,
                    desc1Label: null,
                    desc2Number: null,
                    desc2Date: null,
                    desc2Label: null,
                    horPassDebut: null,
                    horPassFin: null,
                    servTeInfo: null,
                    servOaInfo: null,
                    refCtr: [],
                },
            };
        case 'LOAD_INFOS_COMPL':
            return {
                ...state,
                complInfo: {
                    ...state.complInfo,
                    ...action.payload,
                },
            };
        case 'UPDATE_TRAJET_DESCR':
            return {
                ...state,
                trajetDescr: {
                    ...state.trajetDescr,
                    [action.payload.name]: action.payload.value,
                },
            };
        case 'CLEAR_TRAJET_DESCR':
            return {
                ...state,
                trajetDescr: {
                    depart: null,
                    arrivee: null,
                    type: null,
                    descr: [{
                        numeroSection: null,
                        nomSection: null,
                        passType: null,
                        charge: null,
                        contresens: false,
                        demontage: false,
                        elemPatri: [],
                        expanded: true,
                        road: null,
                        centre: null,
                        centres: [],

                        pointTypeEnter: null,
                        pointCaracEnter: null,
                        sensSectionEnter: null,
                        citySectionEnter: null,
                        prSectionEnter: null,

                        pointTypeExit: null,
                        pointCaracExit: null,
                        sensSectionExit: null,
                        citySectionExit: null,
                        prSectionExit: null,
                    }],
                    descrRetour: [{
                        numeroSection: null,
                        nomSection: null,
                        passType: null,
                        charge: null,
                        contresens: false,
                        demontage: false,
                        elemPatri: [],
                        expanded: true,
                        road: null,
                        centre: null,
                        centres: [],

                        pointTypeEnter: null,
                        pointCaracEnter: null,
                        sensSectionEnter: null,
                        citySectionEnter: null,
                        prSectionEnter: null,

                        pointTypeExit: null,
                        pointCaracExit: null,
                        sensSectionExit: null,
                        citySectionExit: null,
                        prSectionExit: null,
                    }],
                },
            };
        case 'LOAD_TRAJET_DESCR':
            return {
                ...state,
                trajetDescr: {
                    ...state.trajetDescr,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
};

export default requestPassReducer;
